import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { RetailSalesReportDto } from "../../../../dtos/documents/RetailSalesReport/RetailSalesReportDto";
import { FormProvider, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { RetailSalesReportModel } from "../../../../models/Documents/RetailSalesReport/RetailSalesReportModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import { NFLookupCashRegister } from "../../../Shared/NewForms/NFLookupCashRegister";
import { NFLookupCashierShift } from "../../../Shared/NewForms/NFLookupCashierShift";
import { RetailSalesReportPaymentType } from "../../../../dtos/documents/RetailSalesReport/CreateRetailSalesReportDto";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupPaymentRequests } from "../../../Shared/NewForms/NFLookupPaymentRequests";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import RetailSalesReportDetailSkeleton from "./RetailSalesReportDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { RetailSalesReportFooter } from "./RetailSalesReportFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: RetailSalesReportDto | null;
  modelUpdatedEvent: (newModel: RetailSalesReportDto) => void;
}

export const RetailSalesReportDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<RetailSalesReportModel>();

  const RetailSalesReportType = [
    {
      id: RetailSalesReportPaymentType.cash,
      name: "Cash"
    },
    {
      id: RetailSalesReportPaymentType.transfer,
      name: "Transfer"
    },
    {
      id: RetailSalesReportPaymentType.bank,
      name: "Bank"
    },
    {
      id: RetailSalesReportPaymentType.vouchers,
      name: "Vouchers"
    },
    {
      id: RetailSalesReportPaymentType.giftCards,
      name: "Gift Cards"
    }
  ];
  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Return Of Goods From Customers");

  const watchProducts = watch("products");

  useEffect(() => {
    register("products");
    if (model) {
      // setValue("id", model.id);
      setValue("createdDate", model.createdDate);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("status", model.status);
      setValue("comment", model.comment);
      setValue("warehouseId", model.warehouseId);
      setValue("cashRegisterRetailId", model.cashRegisterRetailId);
      setValue("cashierShiftId", model.cashierShiftId);
      setValue("products", model.products);
      setValue("payment", model.payment);
    }
  }, [model]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: RetailSalesReportModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: RetailSalesReportModel = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: RetailSalesReportModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  if (!model) {
    return (
      <>
        <RetailSalesReportDetailSkeleton />
      </>
    );
  }
  const handleVatRateChange = (newVatRate: number, index: number) => {
    const newProducts = [...watchProducts];
    let updatedVatRate = newVatRate;
    const amount: any = newProducts[index].amount;
    // const priceIncludesVat = model.priceIncludeVat;
    let vatAmount;
    //@ts-ignore
    if (priceIncludesVat) {
      vatAmount = amount - amount / ((100 + updatedVatRate) / 100);
    } else {
      vatAmount = (amount * updatedVatRate) / 100;
    }
    newProducts[index].amountWithVat = amount + vatAmount;
    setValue(`products.${index}.vatAmount`, vatAmount);
  };

  const handlevaluechange = (value: any, index: number) => {
    const newProducts = [...watchProducts];
    // let vatRate = newProducts[index].vatRate;

    // if (value === 2) {
    //   vatRate = 18;
    // } else {
    //   vatRate = 0;
    // }
    // console.log(value);

    // setValue(`products.${index}.vatRate`, vatRate);
  };

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.RetailSalesReport.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Payments"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupWarehouse title="warehouseId" fieldName="warehouseId" />
            </Col>
            <Col sm={6}>
              <NFLookupCashRegister title="cashRegisterRetailId" fieldName="cashRegisterRetailId" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCashierShift title="cashierShiftId" fieldName="cashierShiftId" />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"products"}>
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} onValueChanged={handleQuantityChanged} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} onValueChanged={handlePriceChanged} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
            <NFIntInput
              fieldName={"vatRate"}
              title={"vatRate"}
              width={100}
              // onValueChanged={handleVatRateChange}
            />
            <NFIntInput fieldName={"vatAmount"} title={"vatAmount"} width={100} />
            <NFIntInput fieldName={"amountWithVat"} title={"amountWithVat"} width={100} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <NFormTable fieldArray={"payments"}>
            <NFLookupInput title={"Payment Type"} fieldName={"paymentType"} items={RetailSalesReportType} />
            <NFIntInput title="paymentAmount" fieldName="paymentAmount" />
            <NFLookupCustomer title="customer" fieldName="customerId" />
            <NFLookupPaymentRequests title="paymentAccountId" fieldName="paymentAccountId" />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <RetailSalesReportFooter />
    </FormProvider>
  );
};
